import { generatePath } from 'quartz-routing/react-router';
const MY_PLAYLISTS_URL_FRAGMENT = '/saved-items/playlists';
export const MY_PLAYLISTS_TABS = ['all', 'assigned-to-me', 'created-by-me', 'saved', 'archived'];
export const getMyPlaylistsUrl = ({
  tab,
  page
} = {}) => {
  return generatePath(`${MY_PLAYLISTS_URL_FRAGMENT}/:tab?${page ? tab ? '/page/:page' : 'page/:page' : ''}`, {
    tab,
    page
  });
};